import React from 'react';
import { useVersion } from '../contexts/VersionContext';
import useSectionViewTracking from '../hooks/useSectionViewTracking';
import styles from './HowToPlay.module.css';

const HowToPlay = () => {
  const { isImprovedVersion } = useVersion();
  const howToPlayRef = useSectionViewTracking('how_to_play');

  return (
    <section
      ref={howToPlayRef}
      className={`${styles.howToPlay} ${isImprovedVersion ? styles.howToPlayImproved : ''}`}
      id="rules"
    >
      <div className={styles.container}>
        <h2 className={styles.heading}>Rulebook &amp; Media Coming Soon</h2>

        <p className={styles.subtitle}>
          The rulebook and tutorial videos are not available yet. They will be published here as
          soon as the first public versions are ready.
        </p>

        <div className={styles.downloadsGrid}>
          <div
            className={`${styles.mediaCard} ${styles.mediaCardSecondary}`}
            role="region"
            aria-label="Rulebook, releasing soon"
          >
            <span className={styles.releaseBadge}>Releasing Soon</span>
            <div className={styles.cardMedia}>
              <img
                src="/images/webp/rulebook_thumbnail.webp"
                alt="INCEPTUM rulebook cover"
                width={292}
                height={386}
                loading="lazy"
                className={styles.rulebookThumbnail}
              />
              <div className={styles.rulebookImageOverlay} aria-hidden="true" />
            </div>
            <div className={styles.cardBody}>
              <h3 className={styles.cardTitle}>Rulebook</h3>
              <p className={styles.cardSubtitleMuted}>
                Rulebook coming soon.
              </p>
              <p className={styles.cardSupporting}>
                Download access will be enabled once the first public version is ready.
              </p>
            </div>
          </div>

          <div
            className={`${styles.mediaCard} ${styles.mediaCardSecondary}`}
            role="region"
            aria-label="Guides and walkthroughs, releasing soon"
          >
            <span className={styles.releaseBadge}>Releasing Soon</span>
            <div className={styles.cardMediaSecondary}>
              <div className={styles.guidedIconWrap} aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
                  <rect x="4" y="5" width="14" height="10" rx="1.5" opacity="0.35" />
                  <rect x="6" y="8" width="14" height="10" rx="1.5" opacity="0.55" />
                  <rect x="8" y="11" width="14" height="10" rx="1.5" />
                  <path d="M11 15h4M11 18h6" strokeLinecap="round" opacity="0.6" />
                </svg>
              </div>
            </div>
            <div className={styles.cardBody}>
              <h3 className={styles.cardTitle}>Guides &amp; Walkthroughs</h3>
              <p className={styles.cardSubtitleMuted}>
                Tutorial videos coming soon.
              </p>
              <p className={styles.cardSupporting}>
                Step-by-step walkthroughs will be published here after release prep is complete.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowToPlay;
